import React, { Component } from 'react';
import Wizard from './Services/Wizard.js';
var _ = require('lodash');

const GettingStarted = () => <Wizard />;
export default GettingStarted;
